var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_22500)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1723_22500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2741 16.2156L17.7316 23.9934C17.7575 24.4339 18.1223 24.7778 18.5635 24.7778H21.4364C21.6489 24.7778 21.8534 24.6966 22.008 24.5508C22.1627 24.4049 22.2558 24.2056 22.2682 23.9934L22.7257 16.2156C22.7539 15.7369 22.3733 15.3333 21.8939 15.3333H18.1059C17.6265 15.3333 17.246 15.7369 17.2741 16.2156ZM22.9166 28.6667C22.9166 30.2775 21.6108 31.5833 20 31.5833C18.3891 31.5833 17.0833 30.2775 17.0833 28.6667C17.0833 27.0558 18.3891 25.75 20 25.75C21.6108 25.75 22.9166 27.0558 22.9166 28.6667ZM22.8873 3.66563C21.6072 1.44681 18.3951 1.44278 17.1127 3.66563L0.449787 32.5565C-0.829518 34.774 0.772078 37.5556 3.33708 37.5556H36.6625C39.2225 37.5556 40.8316 34.7783 39.5498 32.5565L22.8873 3.66563ZM3.69381 33.5974L19.6391 5.95889C19.7994 5.68097 20.2005 5.68097 20.3609 5.95889L36.3062 33.5973C36.4664 33.8751 36.2659 34.2221 35.9453 34.2221H4.05471C3.73409 34.2222 3.5336 33.8751 3.69381 33.5974Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_22500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35.5556,
    transform: "translate(0 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1723_22500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35.5556,
    transform: "translate(0 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.de63e62134034dfb1120d7d6f6840e8f.svg";
export { ForwardRef as ReactComponent };